import { Action } from '../../definitions/types';
import * as Actions from './actions-consts';
import {
  EXPERIMENT_NAME_SIGNUP_WITH_BACKGROUND,
  EXPERIMENT_NAME_GIVE_ME_FIVE,
  EXPERIMENT_NAME_GIVE_ME_FIVE_DESC,
  EXPERIMENT_NAME_DELAYED_LOGIN,
  EXPERIMENT_NAME_THREE_VERSUS_FIVE,
  EXPERIMENT_NAME_PRODUCT_NAMING,
} from '../../modules/experiment-consts';

import { AppState } from '../reducers';
import { ThunkAction, Dispatch } from 'redux-thunk';
import { Query } from './global';

export const setExperimentByQuery = (query: Query): ThunkAction<void, AppState, void> => {
  return (dispatch: Dispatch<AppState>) => {
    const experiment = query.experiment;

    switch (experiment) {
      case EXPERIMENT_NAME_SIGNUP_WITH_BACKGROUND:
        dispatch(setSignupWithBackground(experiment));
        break;
      case EXPERIMENT_NAME_GIVE_ME_FIVE:
        dispatch(setSignupWithGiveMeFive(experiment));
        break;
      case EXPERIMENT_NAME_GIVE_ME_FIVE_DESC:
        dispatch(setSignupWithGiveMeFiveDesc(experiment));
        break;
      case EXPERIMENT_NAME_DELAYED_LOGIN:
        dispatch(setSignupWithDelayedLogin(experiment));
        break;
      case EXPERIMENT_NAME_THREE_VERSUS_FIVE:
        dispatch(setSignupWithThreeVersusFive(experiment));
        break;
      case EXPERIMENT_NAME_PRODUCT_NAMING:
        dispatch(setSignupWithProductNaming(experiment));
    }
  };
};

export function setSignupWithBackground(experimentName: string): Action<string> {
  return {
    type: Actions.SET_SIGNUP_WITH_BACKGROUND,
    payload: experimentName,
  };
}

export function setSignupWithGiveMeFive(experimentName: string): Action<string> {
  return {
    type: Actions.SET_SIGNUP_WITH_GIVE_ME_FIVE,
    payload: experimentName,
  };
}

export function setSignupWithGiveMeFiveDesc(experimentName: string): Action<string> {
  return {
    type: Actions.SET_SIGNUP_WITH_GIVE_ME_FIVE_DESC,
    payload: experimentName,
  };
}

export function setSignupWithDelayedLogin(experimentName: string): Action<string> {
  return {
    type: Actions.SET_SIGNUP_WITH_DELAYED_LOGIN,
    payload: experimentName,
  };
}

export function setSignupWithThreeVersusFive(experimentName: string): Action<string> {
  return {
    type: Actions.SET_SIGNUP_WITH_THREE_VERSUS_FIVE,
    payload: experimentName,
  };
}

export function setSignupWithProductNaming(experimentName: string): Action<string> {
  return {
    type: Actions.SET_SIGNUP_WITH_PRODUCT_NAMING,
    payload: experimentName,
  };
}
